import React, { useEffect } from "react";
import styles from "./style.module.scss";
import SaveImportsBar from "../SaveImportsBar";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../../state";
import { isEqual } from "lodash";
import { setImportPreviews } from "../../../state/importsReducer";
import ImportSelector from "../ImportSelector";

export default function ImportsConsole() {
  const dispatch = useDispatch();
  const imports = useSelector(
    (state: RootState) => state.imports?.imports,
    isEqual,
  );
  useEffect(() => {
    if (imports) {
      dispatch(setImportPreviews(imports));
    }
  }, [imports, dispatch]);

  return (
    <div className={styles.container}>
      <ImportSelector importName="Energy Management" importType="em" />
      <ImportSelector importName="Strategy" importType="strategy" />
      <ImportSelector importName="Encryption" importType="encryption" />
      <SaveImportsBar />
    </div>
  );
}
